import './NewsLR.scss';
function NewsLR(props) {
  const { news } = props; 
  
  const imageurl = "https://img.freepik.com/free-vector/news-grunge-text_460848-9369.jpg";

  return (
    <div className="news-lr" onClick={() => { window.location.href = "/article?id=" + news.id }}>
        <div className='news-lr-image'>
            <img className='image' width={100} height={100} src={ news.thumbnailUrl || imageurl} alt="News" />
        </div>
        <div className='news-lr-text'>
            <p className='title'>{news.title}</p>
            <span className='date'>{news.date}</span>
        </div>
    </div>
  );
}

export default NewsLR;